import { ref, watch } from 'vue'
import { LABEL_COUNT_LIMIT } from '@/constants.js'

/**
 * ラベルの2段目を件数で止める判定（IFIELD_V4-7151）
 *
 * 1画面に出るラベルが多すぎると吹き出しが重なって読めなくなるため、
 * 一定件数以上では2段目を出さず1段目（名称）だけにする。
 * 間引きはしない（こちら側の判断で情報が欠落するため・2026-08-26 合意）。
 *
 * **件数は「2段目を出しているかどうか」に依存しない経路で数えること。**
 * 描画結果から数えると「止める→0件→戻す→止める」の循環になる。
 */

/**
 * 件数から「2段目を止めるか」を返す
 *
 * 上限ちょうどで出したり消したりを繰り返さないよう、
 * 止めるときと戻すときで閾値を変える
 * @param {Ref.<Number>} count ラベルの件数
 * @returns {Object} 止めているかどうか
 */
export function useLabelCountLimit(count) {
  /**
   * 件数が多すぎて2段目を止めている場合はtrue
   * @type {Ref.<Boolean>}
   */
  const isOverLimit = ref(false)

  watch(
    count,
    (value) => {
      if (!isOverLimit.value && value >= LABEL_COUNT_LIMIT.stop) {
        isOverLimit.value = true
      } else if (isOverLimit.value && value <= LABEL_COUNT_LIMIT.resume) {
        isOverLimit.value = false
      }
    },
    { immediate: true }
  )

  return { isOverLimit }
}
